import { render, staticRenderFns } from "./page.vue?vue&type=template&id=1ebb589c"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=1ebb589c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducatorHero: require('/usr/src/app/components/educator/hero.vue').default,EducatorSpotlight: require('/usr/src/app/components/educator/spotlight.vue').default,EducatorChannel: require('/usr/src/app/components/educator/channel.vue').default,EducatorLive: require('/usr/src/app/components/educator/live.vue').default,EducatorBandsintown: require('/usr/src/app/components/educator/bandsintown.vue').default,EducatorYotpo: require('/usr/src/app/components/educator/yotpo.vue').default,EducatorCourses: require('/usr/src/app/components/educator/courses.vue').default,EducatorSongs: require('/usr/src/app/components/educator/songs.vue').default,EducatorIndie: require('/usr/src/app/components/educator/indie.vue').default,EducatorRaves: require('/usr/src/app/components/educator/raves.vue').default,EducatorItj: require('/usr/src/app/components/educator/itj.vue').default,AuthJoinOrLoginForm: require('/usr/src/app/components/auth/join-or-login-form.vue').default,ModalBasic: require('/usr/src/app/components/modal/basic.vue').default})
